// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CustomerPagingResultModel from '../../model/customer-paging-result-model';
import CustomerPagingResultDTO from '../dto/customer-paging-result-dto';
import CustomerModel from '../../model/customer-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class CustomerPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CustomerPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => CustomerModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  'items'?: CustomerModel[];
  /**
  */
  'links'?: ResourceLinkModel[];
  /**
  */
  'paginationData'?: PaginationDataModel;

  static toModel(dto: DeepPartial<CustomerPagingResultDTO>): CustomerPagingResultModel;
  static toModel(dto: DeepPartial<CustomerPagingResultDTO> | undefined | null): CustomerPagingResultModel | undefined;
  static toModel(dto: DeepPartial<CustomerPagingResultDTO> | undefined | null): CustomerPagingResultModel | undefined {
    return dto ? new CustomerPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CustomerPagingResultModel> | CustomerPagingResultModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'items': unwrapped.items,
      'links': unwrapped.links,
      'paginationData': unwrapped.paginationData,
    } as CustomerPagingResultDTO;
  }
}
